// GET NOTIFICATIONS
export const GET_NOTIFICATIONS = "GET_NOTIFICATIONS"
export const GET_NOTIFICATIONS_SUCCESS = "GET_NOTIFICATIONS_SUCCESS"
export const GET_NOTIFICATIONS_FAIL = "GET_NOTIFICATIONS_FAIL"
export const CLEAR_NOTIFICATIONS = "CLEAR_NOTIFICATIONS"

// LOAD MORE NOTIFICATIONS (for pagination)
export const LOAD_MORE_NOTIFICATIONS = "LOAD_MORE_NOTIFICATIONS"
export const LOAD_MORE_NOTIFICATIONS_SUCCESS = "LOAD_MORE_NOTIFICATIONS_SUCCESS"
export const LOAD_MORE_NOTIFICATIONS_FAIL = "LOAD_MORE_NOTIFICATIONS_FAIL"

// TOGGLE NOTIFICATION READ/UNREAD
export const TOGGLE_NOTIFICATION_READ_UNREAD = "TOGGLE_NOTIFICATION_READ_UNREAD"
export const TOGGLE_NOTIFICATION_READ_UNREAD_SUCCESS = "TOGGLE_NOTIFICATION_READ_UNREAD_SUCCESS"
export const TOGGLE_NOTIFICATION_READ_UNREAD_FAIL = "TOGGLE_NOTIFICATION_READ_UNREAD_FAIL"

// DELETE NOTIFICATION
export const DELETE_NOTIFICATION = "DELETE_NOTIFICATION"
export const DELETE_NOTIFICATION_SUCCESS = "DELETE_NOTIFICATION_SUCCESS"
export const DELETE_NOTIFICATION_FAIL = "DELETE_NOTIFICATION_FAIL"